<ng-container>
  <lib-data-capture-heading id="ddHeader" [QnDescription]="qnData.qDescription"
  [QnSubDescription]="qnData.qSubDescription"></lib-data-capture-heading>
    <lib-check-box id="checkbox" class=".mb-1" [field]="field" [form]="checkboxForm"
    (valueChange)="onValueChange($event)"></lib-check-box>    
  <div class="next-btn-container"> 
        <lib-primary-button id="btnNext" [text]="nextBtn" (clicked)="mapOptionsToAnswers()"
          [disabled]="!checkboxForm.valid" autofocus></lib-primary-button>
  </div>
</ng-container>